import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import _ from 'lodash';
import IconButton from '@material-ui/core/IconButton';
import PersonIcon from '@material-ui/icons/Person';
import ClearIcon from '@material-ui/icons/Clear';
import DeleteIcon from '@material-ui/icons/Delete';
import EmployeeSelect from '../../Common/EmployeeSelect';
import LocalGrid from '../../Common/LocalGrid';
import { uuid } from '../../../utils/helper';
import getNoDataCellComponent from '../../Common/NoDataCellComponent';

import styles from './styles';
import Tooltip from '@material-ui/core/Tooltip';

const COLUMNS = [
  { name: 'role', title: 'Role' },
  { name: 'date', title: 'Date' },
  { name: 'from', title: 'From' },
  { name: 'to', title: 'To' },
  { name: 'employee', title: 'Employee' },
  { name: 'action', title: ' ' },
];

const COLUMN_EXTENSIONS = [
  { columnName: 'date', width: 120 },
  { columnName: 'from', width: 120 },
  { columnName: 'to', width: 120 },
  { columnName: 'action', width: 120 },
];

const getCellComponent = (editable, employees, onSelectEmployee, onRemoveResource) => ({ row, column, value }) => {
  switch (column.name) {
    case 'role':
      return value ? value.name : '';
    case 'date':
      return row.from ? moment(row.from).format('ll') : '';
    case 'from':
      return row.from ? moment(row.from).format('LT') : '';
    case 'to':
      return row.to ? moment(row.to).format('LT') : '';
    case 'employee':
      // console.log('empvalue', value);
      // return (<EmployeeAutoComplete
      //   id={`employee-${row.id}`}
      //   name="employee"
      //   placeholder="Select employee..."
      //   fullWidth
      //   fetchEmployees={fetchEmployees}
      //   value={value}
      //   onChange={(value) => onSelectEmployee(row, value)}
      // />);
      return (<EmployeeSelect
        fullWidth
        employees={employees}
        value={value}
        onChange={(employee) => onSelectEmployee(row, employee)}
      />);
    case 'action':
      return (<div>
        <Tooltip placement="bottom" title="Clear">
          <IconButton
            style={styles.clearEmployee}
            onClick={() => onSelectEmployee(row, null)}
          >
            <ClearIcon style={styles.clearEmployee}/>
          </IconButton>
        </Tooltip>
        <Tooltip placement="bottom" title="Remove">
          <IconButton
            style={styles.removeResource}
            onClick={() => onRemoveResource(row)}
          >
            <DeleteIcon style={styles.removeResource}/>
          </IconButton>
        </Tooltip>
      </div>);
    default:
      return value;
  }

};

class ResourceDetailGrid extends Component {
  handleAddResources = (spec) => {
    const { resources, onChange } = this.props;
    const newResources = _.range(spec.quantity).map(() => _.assign(_.omit(spec, ['quantity']), { id: uuid() }));
    return onChange(_.concat(resources, newResources));
  };

  handleSelectEmployee = (resource, employee) => {
    // console.log('handleSelectEmployee', resource, employee);
    const { value, onChange } = this.props;

    if (employee) {
      return onChange(value.map((r) => {
        if (r.id === resource.id) {
          return _.assign(resource, { employee });
        }

        return r;
      }));
    } else {
      return onChange(value.map((r) => {
        if (r.id === resource.id) {
          return _.omit(resource, ['employee', 'employeeId']);
        }

        return r;
      }));
    }
  };

  handleRemove = (resource) => {
    const { value, onChange } = this.props;
    onChange(value.filter((r) => r.id !== resource.id));
  };

  render() {
    const { value, employees, editable } = this.props;

    return (<div>
      <LocalGrid
        columns={COLUMNS}
        columnExtensions={COLUMN_EXTENSIONS}
        data={value}
        cellComponent={getCellComponent(editable, employees, this.handleSelectEmployee, this.handleRemove)}
        noDataCellComponent={getNoDataCellComponent(<PersonIcon style={styles.noData}/>, 'resources')}
      />
    </div>);
  }
}

ResourceDetailGrid.propTypes = {
  value: PropTypes.array.isRequired,
  employees: PropTypes.array,
  onChange: PropTypes.func.isRequired,
};

export default ResourceDetailGrid;



// WEBPACK FOOTER //
// ./src/components/Resources/ResourceDetailGrid/index.js